<template>
  <div style="height: 100%;">
    <!-- <div v-if="isInit" class="container"> -->
    <div>
      <div class="header" @mousedown.right="handleMouseDownClick($event)">
        <div class="header_div_left">
          <div class="header_div_logo">
            <h1 class="header_logo">{{window.CONFIG.TITLE}}</h1>
          </div>
        </div>
        <div class="logOut" @click="logOut">
          <i class="el-icon-switch-button"></i>
          <span>注销</span>
        </div>
      </div>
      <div class="body">
        <!-- 这一行是为了修复异步加载组件时，表格先渲染完了，才异步加载车牌组件，造成车牌无法显示的BUG -->
        <base-plate v-show="false"></base-plate>
        <router-view></router-view>
      </div>
    </div>
    <div id="qrcode" v-show="false"></div>
  </div>
</template>
<style lang="scss">
  @import "./theme/base.scss";
  @import "./theme/common.scss";
  @import "./theme/element-extend.scss";

  .app-tabs {
    height: 100%;
    position: relative;
    $tabs-header-height: 40px;
    > .el-tabs__header {
      position: absolute;
      left: 0;
      right: 0;
      box-sizing: border-box;
      z-index: 1;
    }
    > .el-tabs__content {
      top: $tabs-header-height;
      height: calc(100% - #{$tabs-header-height});
      overflow: auto;
      box-sizing: border-box;
      .el-container > .el-main {
        padding: 10px;
        margin: -10px;
        box-sizing: content-box;
        overflow: visible;
        height: auto;
      }
    }
  }

  .el-menu {
    .el-submenu__title {
      background: #002556;
      margin-bottom: 2px;
      height: 40px;
      line-height: 40px;
      i {
        font-size: 16px;
      }
      .el-submenu__icon-arrow {
        font-weight: bold;
      }
    }
    .nav .el-menu-item.is-active {
      color: #fff;
      background: #4b86d6;
    }
    .el-menu--inline {
      /*background-color:#FFF;*/
    }
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      /*margin:5px;*/
    }
    .el-submenu__title i {
      color: $color-font-normal;
      margin-right: 5px;
    }
    .el-menu-item:hover {
      background: $color-highlight;
    }
    .el-menu-item.is-active {
      color: #fff;
      background: $color-highlight;
      box-shadow: inset 0 0 5px #def7fb;
      i {
        color: #fff;
      }
      .menu-tiem-i {
        background: #fff;
      }
    }
  }

  .ws_alarm_pop {
    position: fixed;
    background: #fff;
    bottom: 20px;
    right: 20px;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    div {
      position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: red;
      right: -2px;
      top: -5px;
      i {
        color: #fff;
        position: relative;
        top: -3px;
        left: 1px;
        font-size: 12px;
      }
    }
    span {
      color: red;
    }
  }

  .ws_alarm_pop:hover {
    background: #f0f0f0;
  }

  .ol-overlay-container-z-index {
    z-index: 3;
  }

  /*.ol-overlay-container:hover {*/
  /*z-index: 3;*/
  /*}*/
</style>
<style lang="scss" scoped>
  .contextmenu {
    border: 1px solid $color-font-disabled;
    background-color: $color-back-white;
    box-shadow: $box-shadow;
    z-index: 4321;
    li {
      padding-left: $padding-small;
      padding-right: $padding-small;
      box-sizing: border-box;
      line-height: $line-height-middle;
      cursor: pointer;
      &:hover {
        background-color: $color-shalow-blue;
      }
    }
  }

  $menu-width: 200px; // 菜单宽度
  $header-height: 60px; // 头部栏宽度
  .container {
    height: 100%;
  }

  .header {
    height: $header-height;
    line-height: $header-height;
    margin-bottom: 0;
    background-color: #020816;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    border-top: 5px solid #09142e;
    display: flex;
    justify-content: space-between;
    padding-right: 30px;
    position: relative;
    .logOut{
      position: absolute;
      top: 0px;
      right: 40px;
      z-index: 99;
      font-size: 30px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      span{
        font-size: 20px;
        margin-left: 10px;
      }
    }
    .header_div_left {
      width: 37%;
      min-width: 760px;
      display: flex;
    }
    div.header_div_logo {
      width: 80%;
      min-width: 405px;
      position: relative;
      background: #005D5D;
      margin-right: 55px;
      box-sizing: border-box;
      padding-left: 30px;
      display: flex;
      h1 {
        width: 100%;
        font-size: $font-size-h1;
        color: #fff;
        background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgba(255, 255, 255, 1)), to(rgba(204, 204, 204, 1)));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: 700;
        position: relative;
        letter-spacing: 2px;
        font-style: italic;
      }
    }
    div.header_div_logo:after {
      content: "";
      width: 0;
      height: 0;
      border-top: 55px solid #005D5D;
      border-right: 55px solid transparent;
      position: absolute;
      right: -55px;
      top: 0;
    }
    .header_situation {
      width: 14%;
      color: #63dcd8;
      position: relative;
      background: #005D5D;
      box-sizing: border-box;
      margin: 10px 45px 0 7px;
      display: flex;
      > div {
        width: 100%;
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: center;
        p:first-child {
          line-height: 45px;
          height: 45px;
          text-align: center;
          margin-right: 5px;
          i {
            font-size: 30px;
            line-height: 45px;
          }
        }
        p:last-child {
          font-size: 16px;
          line-height: 45px;
          text-align: center;
        }
      }
      > div:hover {
        color: rgba(99, 220, 216, 0.8);
      }
    }
    div.header_situation:before {
      content: "";
      width: 0;
      height: 0;
      border-bottom: 45px solid #005D5D;
      border-left: 45px solid transparent;
      position: absolute;
      left: -45px;
      top: 0;
    }
    div.header_situation:after {
      content: "";
      width: 0;
      height: 0;
      border-top: 45px solid #005D5D;
      border-right: 45px solid transparent;
      position: absolute;
      right: -45px;
      top: 0;
    }
    .header_broadcast {
      width: 30%;
      color: #4da7e7;
      line-height: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      i {
        font-size: 26px;
        line-height: 50px;
        margin-right: 10px;
      }
      span {
        display: block;
      }
    }
    .header_info {
      width: 20%;
      min-width: 378px;
      color: #63dcd8;
      display: flex;
      > div {
        width: 50px;
        position: relative;
        cursor: pointer;
        margin-right: 20px;
        > div.red-circular {
          width: 15px;
          height: 15px;
          background: red;
          border-radius: 50%;
          position: absolute;
          right: 10px;
          top: 0;
        }
        p:first-child {
          line-height: 32px;
          height: 32px;
          text-align: center;
          i {
            font-size: 26px;
            line-height: 40px;
          }
        }
        p:last-child {
          font-size: 12px;
          line-height: 20px;
          text-align: center;
        }
        a.download {
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          display: block;
        }
        > div.header_info_app:hover {
          > p:first-child {
            color: rgba(99, 220, 216, 0.8);
          }
          > p:last-child {
            color: rgba(99, 220, 216, 0.8);
          }
        }
        > div.QR-code {
          position: absolute;
          top: 0;
          left: -125px;
          width: 300px;
          height: 370px;
          margin-top: 70px;
          background: rgba(0, 0, 0, 0.8);
          border: 2px solid #174857;
          z-index: 9;
          .QR-code-top {
            width: 100%;
            height: 300px;
            padding: 15%;
            position: relative;
            box-sizing: border-box;
            border-bottom: 2px solid #174857;
            .bor-color {
              width: 28px;
              height: 28px;
              position: absolute;
            }
            .QR-code-top-cont {
              width: 100%;
              height: 100%;
              padding: 10px;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
              }
              p {
                color: #03d8ff;
                line-height: 44px;
              }
            }
          }
          .QR-code-bottom {
            width: 100%;
            height: 70px;
            button {
              width: 150px;
              margin: 21px 75px;
            }
            span {
              color: #03d8ff;
            }
          }
          .triangle-up {
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 16px solid #174857;
            position: absolute;
            top: -16px;
            left: 50%;
            margin-left: -5px;
          }
          .hide-QRCode {
            position: absolute;
            right: 2px;
            top: 2px;
            z-index: 2;
            i {
              font-size: 20px;
              display: block;
            }
          }
        }
      }
      > div:hover {
        > p:first-child {
          color: rgba(99, 220, 216, 0.8);
        }
        > p:last-child {
          color: rgba(99, 220, 216, 0.8);
        }
      }
      .header_info_alarm {
        width: 13px;
        height: 13px;
        display: block;
        position: absolute;
        border-radius: 100%;
        top: 0;
        right: 0;
        background-color: red;
      }
    }
    .loginOut {
      width: 10%;
      min-width: 180px;
      p {
        line-height: 50px;
        height: 50px;
        color: #d3d4d6;
        display: flex;
        float: right;
        span {
          display: block;
          margin: 0 30px 0 5px;
          cursor: pointer;
        }
        i:first-child {
          font-size: 26px;
          line-height: 50px;
        }
        i:last-child {
          font-size: 26px;
          line-height: 50px;
          color: #63dcd8;
          cursor: pointer;
        }
        i:last-child:hover {
          color: rgba(99, 220, 216, 0.8);
        }
        img {
          width: 40px;
          height: 40px;
          margin: 5px 0;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }
  }

  .body {
    overflow: hidden;
    height: calc(100% - #{$header-height});
    background: #020816;
  }

  .index-menu-box {
    width: $menu-width;
    height: 100%;
    overflow: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    .el-menu {
      border: none;
      width: 200px;
      height: calc(100% - 112px);
    }
  }

  .aside-top {
    width: 100px;
    height: 32px;
    background: #1c2a36;
    > div {
      float: left;
      width: 50%;
      height: 32px;
      box-sizing: border-box;
      background-color: #49545e;
      cursor: pointer;
      text-align: center;
      img {
        width: 18px;
        height: 18px;
        margin: 7px 0;
      }
    }
    > div:hover {
      background-color: #3d454c;
    }
  }

  .menu-box {
    width: $menu-width;
    height: 100%;
    overflow: auto;
    float: left;
    margin-top: 10px;
    background: linear-gradient(#050d20, #082648);
    position: relative;

    .upload-button{
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .el-menu {
    height: 100%;
    border-right: none;
  }

  .tabs-box {
    float: right;
    width: calc(100% - #{$menu-width});
    height: 100%;
    padding: 10px;
    margin-left: 0;
    box-sizing: border-box;
    overflow: auto;
    > * {
      height: 100%;
      /*transform:translateX(0); // 用于使主要内容区域（右侧）里的对话框能够相对于主要内容区域居中*/
    }
  }

  .tabs {
    border: none;
    box-shadow: none;
  }
</style>
<style lang="scss">
  // 全局样式
  /*@import './libs/optiscroll/optiscroll.css';*/
  @font-face {
    font-family: "iconfont";
    src: url('../libs/fonts/iconfont.eot?t=1488869681899'); /* IE9*/
    src: url('../libs/fonts/iconfont.eot?t=1488869681899#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('../libs/fonts/iconfont.woff?t=1488869681899') format('woff'), /* chrome, firefox */
    url('../libs/fonts/iconfont.ttf?t=1488869681899') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/
    url('../libs/fonts/iconfont.svg?t=1488869681899#iconfont') format('svg'); /* iOS 4.1- */
  }

  .icon {
    // background-image:url('./assets/imgs/sprites.png');
    font-family: iconfont, 微软雅黑 !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .el-message-box__content {
    .el-message-box__input {
      padding-left: 36px;
      padding-right: 12px;
    }
    .el-message-box__status.el-icon-warning {
      top: 28px;
    }
  }

  .data-wrapper-header-remark {
    padding: 8px 0;
    font-size: 16px;
    font-weight: bold;
    color: #e0cb1b;
    border-radius: 4px;
    text-align: center;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../src/layout/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../src/layout/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../src/layout/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-layout')
  export default {
    name: 'layout', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'layout': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../base-components/account-info/index.vue').default,
       'base-back': require('./../base-components/back/index.vue').default,
       'base-blackHandle': require('./../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../base-components/check-all/index.vue').default,
       'base-cropper': require('./../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../base-components/dialog/index.vue').default,
       'base-empty': require('./../base-components/empty/index.vue').default,
       'base-export': require('./../base-components/export/index.vue').default,
       'base-filter': require('./../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../base-components/key-value/index.vue').default,
       'base-my-column': require('./../base-components/my-column/index.vue').default,
       'base-number-input': require('./../base-components/number-input/index.vue').default,
       'base-plate': require('./../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../base-components/yearrange/index.vue').default,
       'business-account-info': require('./../business-components/account-info/index.vue').default,
       'business-alarm-badge': require('./../business-components/alarm-badge/index.vue').default,
       'business-car-type-cascader': require('./../business-components/car-type-cascader/index.vue').default,
       'business-data-export-dialog': require('./../business-components/data-export-dialog/index.vue').default,
       'business-Multi-table': require('./../business-components/Multi-table/index.vue').default,
       'business-newTable-pagination': require('./../business-components/newTable-pagination/index.vue').default,
       'business-node-cascader': require('./../business-components/node-cascader/index.vue').default,
       'business-org-cascader': require('./../business-components/org-cascader/index.vue').default,
       'business-page-picture-content': require('./../business-components/page-picture-content/index.vue').default,
       'business-page-picture-contentV2': require('./../business-components/page-picture-contentV2/index.vue').default,
       'business-page-picture-contentV3': require('./../business-components/page-picture-contentV3/index.vue').default,
       'business-page-sub-title': require('./../business-components/page-sub-title/index.vue').default,
       'business-page-tabs': require('./../business-components/page-tabs/index.vue').default,
       'business-page-title': require('./../business-components/page-title/index.vue').default,
       'business-table-dialog': require('./../business-components/table-dialog/index.vue').default,
       'business-table-pagination': require('./../business-components/table-pagination/index.vue').default,
       'business-update-confirm-status': require('./../business-components/update-confirm-status/index.vue').default,
       'business-update-deal-status': require('./../business-components/update-deal-status/index.vue').default,
       'private-submenu': require('./components/submenu/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>